import {withYoutubeApi, withVimeoApi} from "../define/shared";

export default function initVideos() {
    const videos = [].slice.call(document.querySelectorAll('.themeVideo'));

    videos.forEach(initVideo);
}

// https://vimeo.com/287060201
// https://youtu.be/mkjwxmcdb0E?si=YDMHmwbkESdPo_r7

function initVideo(root) {
    const containerEl = root.querySelector('.themeVideo-inner');
    const provider = root.dataset.provider;
    const id = root.dataset.id;

    if (!id) {
        return;
    }

    if (provider === 'youtube') {
        withYoutubeApi((youtube) => {
            const player = new youtube.Player(containerEl, {
                videoId: id,
                playerVars: {
                    autoplay: 1,
                    controls: 0,
                    autohide: 1,
                    showinfo: 0,
                    rel: 0,
                    modestbranding: 1,
                    playsinline: 1
                },
                events: {
                    onReady: () => {
                        player.mute();
                        player.playVideo();
                        adjustVideoSize(root);
                    },
                    onStateChange: event => {
                        if (event.data === YT.PlayerState.ENDED) {
                            player.playVideo();
                        }
                    },
                },
            });
        })
    } else if (provider === 'vimeo') {
        withVimeoApi((vimeo) => {
            const player = new vimeo.Player(containerEl, {
                id: id,
                autoplay: true,
                background: true,
                muted: true
            })

            player.on('loaded', () => {
                adjustVideoSize(root);
            })
        })
    }
}

function adjustVideoSize(container) {
    const iframe = container.querySelector("iframe");

    if (!iframe) {
        return;
    }

    const wrapperWidth = container.offsetWidth;
    const wrapperHeight = container.offsetHeight;
    const wrapperAspectRatio = wrapperWidth / wrapperHeight;

    if (wrapperAspectRatio > 16/9) {
        iframe.style.height = wrapperWidth * 9 / 16 + "px";
    } else {
        iframe.style.width = wrapperHeight * 16 / 9 + "px";
    }
}
